import React from "react";
import EventBanner from "../assets/images/eventbanner.webp";
import "../assets/css/EventBanner.css";

const Banner = () => {
  return (
    <div className="lg:flex  md:space-x-20 md:space-y-8 space-y-6 my-20 justify-center w-full ">
      <div className="w-6/6 ">
        <a href="https://events.spandanfhv.in/charcha-2024/">
          <img
            src={EventBanner}
            alt="EventBanner"
            width="100%"
            height="100%"
            className="w-full object-contain object-center web-box-shadow"
          />
        </a>
      </div>
      <div>
        <p className="title-font text-5xl font-semibold text-101828 mb-8 inline-block">
          Join the Conversation
        </p>
        <p className="mb-8 leading-relaxed text-lg text-667085">
          Charcha 2024: A Declamation Contest in Honor of Dr. GP Rao’s
          Contribution to Human Values
        </p>
        <div className="mb-6">
          <p className="text-101828 text-md font-semibold">
            Date: Friday, February 23rd, 2024
          </p>
          <p className="text-101828 text-md font-semibold">Time: 10:00 AM </p>
          <p className="text-101828 text-md font-semibold">
            Venue: GJIMT Campus
          </p>
        </div>

        <div className="my-4">
          <a href="https://events.spandanfhv.in/charcha-2024/">
            <button className="inline-flex items-center bg-088AB2 border-0 py-2 px-4 focus:outline-none hover:bg-gray-200 rounded-8 text-white mt-4 md:mt-0">
              Register Now{" "}
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Banner;
